import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue";
import _imports_0 from '@/assets/mapv2/bgyunl.png';
import _imports_1 from '@/assets/mapv2/bgyunr.png';
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_12 = {
  key: 0,
  class: "routeDialog"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 2,
  class: "yunbox"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "componentswrap"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "data-content"
};
const _hoisted_21 = {
  class: "dateitem"
};
const _hoisted_22 = {
  class: "dateitem"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "dateitem"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  const _component_DArrowRight = _resolveComponent("DArrowRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_pointlistv2 = _resolveComponent("pointlistv2");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_routelist = _resolveComponent("routelist");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapContainer", {
      'isMobile': $data.isMobile
    }]),
    style: _normalizeStyle($data.mainStyle),
    "element-loading-text": "加载数据中..."
  }, [_createElementVNode("div", {
    class: _normalizeClass([`formUserId${$data.formUserId}`]),
    style: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.mapelem.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.mapelem.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.mapelem.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.mapelem.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.mapelem.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.mapelem.pickey !== '']]), $data.loadingmap ? (_openBlock(), _createBlock(_component_mapv2assembly, {
    key: 0,
    ref: "mapv2assembly",
    id: $data.id,
    showgdtilelayer: $data.mapLayers.tiles,
    showgeojsonlayer: $data.mapLayers.json,
    showstaticlayer: $data.mapLayers.static,
    showroutelayer: $data.mapLayers.route,
    staticimage: $data.mapLayers.staticimage,
    drawelement: $data.mapLayers.drawelement,
    geojson: $data.mapLayers.geojson,
    mapstyle: $data.mapstyle,
    adcode: $data.mapview.adcode,
    zoom: $data.mapview.zoom,
    minZoom: $data.mapview.minZoom,
    maxZoom: $data.mapview.maxZoom,
    extent: $data.mapview.extent,
    center: $data.mapview.center,
    scale: $data.mapview.scale,
    rotate: $data.mapview.rotate,
    translate: $data.mapview.translate,
    rotation: $data.mapview.rotation,
    streetcode: $data.mapstreetcode,
    pointlist: $data.pointList,
    culturallist: $data.mapculturalList,
    isMobile: $data.isMobileflag,
    onSingleclick: $options.singleclick,
    onMarkerclick: $options.markerclick,
    onMarkermoveend: $options.markermoveend
  }, null, 8, ["id", "showgdtilelayer", "showgeojsonlayer", "showstaticlayer", "showroutelayer", "staticimage", "drawelement", "geojson", "mapstyle", "adcode", "zoom", "minZoom", "maxZoom", "extent", "center", "scale", "rotate", "translate", "rotation", "streetcode", "pointlist", "culturallist", "isMobile", "onSingleclick", "onMarkerclick", "onMarkermoveend"])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "control-menu",
    onClick: _cache[0] || (_cache[0] = $event => $data.typeUlFlag = !$data.typeUlFlag)
  }, _cache[6] || (_cache[6] = [_createElementVNode("span", null, "菜单", -1)])), _withDirectives(_createElementVNode("ul", {
    class: _normalizeClass(["typeListUl", {
      'zIndex': $data.typeUlzIndex
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.typeIndex === index + 1
      }),
      key: index,
      onClick: _withModifiers($event => $options.typeUlswtich(index + 1, item), ["stop"])
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), item.type && item.type.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.type, (child, cdIndex) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass({
          'active': $data.typechildIndex === cdIndex
        }),
        key: child,
        onClick: _withModifiers($event => $options.typeUlswtich(cdIndex, item, 1, child), ["stop"])
      }, _toDisplayString(child), 11, _hoisted_7);
    }), 128))])) : _createCommentVNode("", true), item.children && item.children.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, cdIndex) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass({
          'active': $data.typechildIndex === cdIndex
        }),
        key: child,
        onClick: _withModifiers($event => $options.typeUlswtich(cdIndex, item, 1, child), ["stop"])
      }, _toDisplayString(child.name), 11, _hoisted_9);
    }), 128))])) : _createCommentVNode("", true)], 10, _hoisted_5);
  }), 128))], 2), [[_vShow, $data.typeUlFlag]]), _createVNode(_component_mappopupv2, {
    detail: $data.pointdetail,
    popshowflag: $data.popshowflag,
    modeltype: $data.popmodeltype,
    isMobile: $data.isMobileflag,
    id: $data.id,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "isMobile", "id", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["golist", `fid${$data.query.fid}`]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.golist && $options.golist(...args))
  }, [_createElementVNode("img", {
    src: $data.mapelem.golist,
    alt: ""
  }, null, 8, _hoisted_10)], 2), [[_vShow, $data.showgolist]]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["control-list-btn", {
      'on': $data.showlistflag === 1
    }]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.showcontrolList && $options.showcontrolList(...args))
  }, [_createTextVNode(_toDisplayString($data.showlistflag === 0 ? '展开' : '收起') + "筛选 ", 1), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_DArrowRight)]),
    _: 1
  })], 2), [[_vShow, $data.listFlag]]), _createVNode(_component_pointlistv2, {
    ref: "pointlist",
    listshowflag: $data.showlistflag,
    formoption: $data.cTemplateScore === 1 ? $data.cformoption : $data.typeList,
    datalist: $data.cTemplateScore === 1 ? $data.mapculturalList : $data.pointList,
    modeltype: $data.mapstyle.listStyleIndex,
    style: _normalizeStyle($data.modulestyle.list),
    isMobile: $data.isMobileflag,
    typeindex: $data.typeIndex,
    otheroption: $data.menuList[$data.typeIndex - 1],
    recordtype: $data.recordType,
    onListclick: $options.pointlistClick,
    onListup: $options.listUp
  }, null, 8, ["listshowflag", "formoption", "datalist", "modeltype", "style", "isMobile", "typeindex", "otheroption", "recordtype", "onListclick", "onListup"]), _createElementVNode("div", _hoisted_11, null, 512), _createVNode(_component_el_dialog, {
    modelValue: $data.routePop,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.routePop = $event),
    title: "路线详情",
    width: $data.isMobileflag ? '80%' : '40%'
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[3] || (_cache[3] = $event => $data.routePop = false)
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确定")])),
      _: 1
    })]),
    default: _withCtx(() => [_ctx.routeDetail ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("h3", null, _toDisplayString(_ctx.routeDetail.itemformdata.title), 1), _createElementVNode("div", {
      class: "introduce",
      innerHTML: _ctx.routeDetail.itemformdata.introduce
    }, null, 8, _hoisted_13)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "width"]), _createVNode(_component_routelist, {
    ref: "routelist",
    typelist: $data.rtypeList,
    routelist: $data.maprouteList,
    pointlist: $data.pointList,
    style: _normalizeStyle($data.mapstyle),
    isMobile: $data.isMobileflag,
    id: $data.id,
    onRoute: $options.routeChange
  }, null, 8, ["typelist", "routelist", "pointlist", "style", "isMobile", "id", "onRoute"]), $data.mapsenior.visit ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "visitWrap",
    style: _normalizeStyle($data.modulestyle.visit)
  }, [_withDirectives(_createElementVNode("span", null, _toDisplayString($data.mapsenior.visitname), 513), [[_vShow, $data.mapsenior.visitname !== '']]), _createElementVNode("span", null, _toDisplayString($data.visitItem[0].num), 1)], 4)) : _createCommentVNode("", true), $data.mapsenior.effect ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[8] || (_cache[8] = [_createElementVNode("img", {
    class: "yunl",
    src: _imports_0,
    alt: ""
  }, null, -1), _createElementVNode("img", {
    class: "yunr",
    src: _imports_1,
    alt: ""
  }, null, -1)]))) : _createCommentVNode("", true), $data.mapsenior.bgaudio ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "bgaudio",
    style: _normalizeStyle($data.modulestyle.bgaudio),
    onClick: _cache[5] || (_cache[5] = (...args) => $options.bgaudioHandle && $options.bgaudioHandle(...args))
  }, [_createElementVNode("img", {
    src: $data.mapelem.bgaudio
  }, null, 8, _hoisted_15)], 4)) : _createCommentVNode("", true), $data.mapsenior.bgaudio ? (_openBlock(), _createElementBlock("audio", {
    key: 4,
    ref: "bgaudio",
    id: "bgaudio",
    controls: "",
    autoplay: "",
    loop: "loop",
    src: $data.bgaudio,
    style: {
      "width": "0",
      "height": "0"
    }
  }, null, 8, _hoisted_16)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.editorList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "image-item",
      key: index,
      style: _normalizeStyle($options.getdomStyle(item.style)),
      onClick: $event => $options.domChange(item)
    }, [_createElementVNode("img", {
      src: item.image[0].fileUrl,
      alt: ""
    }, null, 8, _hoisted_19)], 12, _hoisted_18);
  }), 128))], 512), [[_vShow, $data.editorList.length > 0]]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[9] || (_cache[9] = _createElementVNode("h2", null, "文化活动", -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.whhdSum, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "number-item",
      key: item
    }, [_createElementVNode("span", null, [_createElementVNode("i", {
      class: "item",
      ref_for: true,
      ref: "numberItem",
      style: _normalizeStyle({
        'transform': `translate(-50%, -${item.val * 10}%)`
      })
    }, "0123456789", 4)])]);
  }), 128))])]), _createElementVNode("div", _hoisted_22, [_cache[10] || (_cache[10] = _createElementVNode("h2", null, "文化空间", -1)), $data.whkjSum.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.whkjSum, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "number-item",
      key: item
    }, [_createElementVNode("span", null, [_createElementVNode("i", {
      class: "item",
      ref_for: true,
      ref: "numberItem",
      style: _normalizeStyle({
        'transform': `translate(-50%, -${item.val * 10}%)`
      })
    }, "0123456789", 4)])]);
  }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_cache[11] || (_cache[11] = _createElementVNode("h2", null, "文化设施", -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.whssSum, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "number-item",
      key: item
    }, [_createElementVNode("span", null, [_createElementVNode("i", {
      class: "item",
      ref_for: true,
      ref: "numberItem",
      style: _normalizeStyle({
        'transform': `translate(-50%, -${item.val * 10}%)`
      })
    }, "0123456789", 4)])]);
  }), 128))])])])], 2)], 6)), [[_directive_loading, $data.allLoading, void 0, {
    fullscreen: true,
    lock: true
  }]]);
}